import React, { useContext } from 'react';
import {
	fontFamily,
	textAlign,
	lineHeight,
	fontWeight,
	fontSize,
	letterSpacing,
	color,
	space,
	fontStyle,
	flexWrap,
	width,
	border,
	shadow,
	layout,
	typography,
} from 'styled-system';
import styled from 'styled-components';
import { ThemeContext } from 'styled-components';

const Content = styled.div`
    ${fontSize}
    ${fontFamily}
    ${textAlign}
    ${lineHeight}
    ${fontWeight}
    ${letterSpacing}
    ${color}
    ${space}
    ${fontStyle}
    ${flexWrap}
		${width}
		${border}
		${shadow}
		${layout}
		${typography}
`;

const Text = ({ className, html, ...restProps }) => {
	const theme = useContext(ThemeContext);
	const ht = html ? { dangerouslySetInnerHTML: { __html: html } } : {};
	return <Content {...theme.text} {...ht} {...restProps} />;
};

export default Text;
